// extracted by mini-css-extract-plugin
export var cardIcon = "_69-5";
export var cardIconUnframed = "_69-9";
export var checkboxCard = "_69-0";
export var checkboxCardSelected = "_69-4";
export var disabled = "_69-2";
export var interactive = "_69-1";
export var outerBorder = "_69-3";
export var spacerMedium = "_69-8";
export var spacerSmall = "_69-7";
export var spacerXsmall = "_69-6";